import React, { useState } from 'react';

const RegularInputForSettings = props => {
    
    let {
        value,
        settingName,
        switchers,
        handleInputChange
    } = props;

    const [ localState, toggleLocalState ] = useState(value);

    const handleCLickingSwitchers = direction => {
        handleInputChange({ target: { name: name, value: direction === 'minus' ? localState - 1 : localState + 1 } }, true);
        toggleLocalState(state => direction === 'minus' ? state - 1 : state + 1);
    };

    const handleChange = e => {
        handleInputChange(e);
        toggleLocalState(e.target.value);
    };

    const plusMinusButtonStyle = {
        padding: '2px 5px',
        width: '3.0rem',
        borderRadius: '3px'
    };

    return (
        <span>
            <input
                style={{
                    width: '50px',
                    borderRadius: '3px'
                }}
                value={localState}
                name={settingName}
                onChange={e => handleChange(e)}
            />
            {
                switchers && (
                    <span>
                        <button
                            onClick={() => handleCLickingSwitchers('minus')}
                            style={plusMinusButtonStyle}
                        >
                            -
                        </button>
                        <button
                            onClick={() => handleCLickingSwitchers('plus')}
                            style={plusMinusButtonStyle}
                        >
                            +
                        </button>
                    </span>
                )
            }
        </span>

    );
    
    
};

export default RegularInputForSettings;